import React from 'react';
import './LoadingSpinner.css'; // Import your CSS file

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
